import React, { useEffect } from 'react';
import { Card } from 'antd';
import SaleList from '../../components/Sale/SaleList';
import { useSale } from '../../store/saleContext';
import { useNavigate } from 'react-router';

const SaleListPage: React.FC = () => {
    const { fetchSales } = useSale();
    const navigate = useNavigate();

    useEffect(() => {
        fetchSales();
    }, []);
    const handleEdit = (ret: any) => {
        navigate(`/sales/form/${ret.id || ret._id}`);
    };
    return (
        <div style={{ padding: 16 }}>
            <Card title="Sales List">
                <SaleList onEdit={handleEdit} />
            </Card>
        </div>
    );
};

export default SaleListPage;
